import React from 'react';
import { SxProps, Box } from '@mui/material';

export interface TabPanelProps {
    children?: React.ReactNode;
    sx?: SxProps;
    index: number;
    value: number;
}

/**
 * This should be used to hold the content of a particular tab, and will be
 * a sibling of StyledTabs. Be sure to pay attention to the assigned index,
 * since that is how the MUI onChange handler determines the visible tab
 */
export const TabPanel = ({ index, value, children, sx }: TabPanelProps) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            sx={Array.isArray(sx) ? sx : [sx]}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </Box>
    );
};
